module.exports = "<span class=\"toast\">\n{{data}}\n</span>\n "